export const isDrawableStatisticSample = (
	missing: boolean | undefined,
	value: unknown,
): value is number => {
	const numericValue = Number(value);
	return !missing && value != null && Number.isFinite(numericValue) && Math.abs(numericValue) !== 999;
};
